/**
 * CRO-optimised single-column entry · mirrors
 * docs/design-preview/option-b/wave-1/01c-login-cro.html.
 *
 * The page renders: brand top-bar, centered card (hero + social-first
 * auth stack + email-first form + trust halo + testimonial), bottom
 * tagline. There's no signup/login mode toggle — the form is unified:
 * we try signIn first, fall back to signUp on UserNotFound. The
 * Cognito pool auto-confirms via PreSignUp Lambda so both paths land
 * the user on the dashboard.
 */
import { Navigate, useNavigate, useSearchParams } from 'react-router';

import { paths } from '@/config/paths';

import { AuthFormShell } from '../components/auth-form-shell';
import { useAuth } from '../hooks/use-auth';

import styles from './get-started.module.css';

export function GetStartedPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { isAuthenticated, isLoading } = useAuth();

  const reason = params.get('reason');

  if (!isLoading && isAuthenticated) {
    const next = params.get('next');
    return <Navigate to={next ?? paths.dashboard} replace />;
  }

  const handleSignedIn = () => {
    const next = params.get('next');
    void navigate(next ?? paths.dashboard, { replace: true });
  };

  return (
    <div className={styles.page}>
      {/* Dev-only ribbon marking this as the recommended ship version,
          mirrors the design's `.ribbon`. */}
      <span className={styles.ribbon}>CRO recommended</span>

      <div className={styles.top}>
        {/* Brand links to the app home, mirroring the design's
            `../dashboard.html`. ProtectedRoute bounces a logged-out
            visitor back here, so the click is harmless either way. */}
        <a className={styles.brand} href={paths.dashboard}>
          <div className={styles.brandMark}>
            <img src="/brand/brand-mark.svg" alt="" />
          </div>
          <div className={styles.brandName}>
            Avatar<span>Factory</span>
          </div>
        </a>
        <div />
      </div>

      {reason === 'session-expired' ? (
        <div className={styles.banner} role="status">
          <span className={styles.bannerIcon} aria-hidden="true">
            ⌛
          </span>
          Your session expired. Sign in again to keep going.
        </div>
      ) : null}

      <div className={styles.centerWrap}>
        <AuthFormShell onSignedIn={handleSignedIn} />
      </div>

      <div className={styles.foot}>20,000+ creators · 1,389 channels past 1M followers</div>
    </div>
  );
}

// Allow the lazy router to default-import this.
export default GetStartedPage;
